module.exports = __webpack_public_path__ + "img/applepay.d4c67d38.svg";